export const SelectedForVerificationFilterEnum = {
  'Results Input': 0,
  'Confirmation Review': 1,
};



// WEBPACK FOOTER //
// ./src/pages/selectedforverification/components/Constants.js